import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {MatTableDataSource} from '@angular/material/table';
import * as XLSX from 'xlsx';
import {CommonService} from '../../../services/common.service';
import {FileService} from '../../../services/file.service';
import {ToastMessagesService} from '../../../services/toast-messages.service';
import {EmailInfoDialogComponent} from '../../dialogs/email-info-dialog/email-info-dialog.component';


@Component({
  selector: 'app-report-details-table',
  templateUrl: './report-details-table.component.html',
  styleUrls: ['./report-details-table.component.scss']
})
export class ReportDetailsTableComponent implements OnInit {
  @ViewChild('tableContainer', {static: false}) table: ElementRef;
  @Input() uniqueId;
  @Input() questionId;
  @Input() dataSource;
  @Input() state;
  @Input() report;
  data: MatTableDataSource<any>;
  infoTable = [];
  documentTitle: string;
  pdfExtention = '.pdf';
  excelExtention = '.xlsx';
  // columnsToDisplay = ['parentFirstName', 'parentLastName', 'email', 'provider', 'childName', 'childClass'];
  columnsToDisplay = ['childName', 'childLastName', 'childClass'];

  constructor(private fileService: FileService, public commonService: CommonService,
              public dialog: MatDialog, public toastMessagesService: ToastMessagesService) {
  }

  ngOnInit(): void {
    this.formatData();
    if (+this.state === 0) {
      this.columnsToDisplay.push('status');
      this.columnsToDisplay.push('consentDate');
    }

    if (+this.state === 1 || +this.state === 2) {
      this.columnsToDisplay.push('consentDate');
    }
    console.log(this.infoTable);
    // this.data = new MatTableDataSource<any>(this.dataSource);
    this.data = new MatTableDataSource<any>(this.infoTable);
    const prefix = +this.state === 1 ? 'Αποδοχή' :
        +this.state === 2 ? 'Απόρριψη' :
            +this.state === -1 ? 'Σε αναμονή' : 'Όλοι';
    this.documentTitle = `${prefix}-${this.report.title}`;
  }

  exportToExcel() {
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.table.nativeElement);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, `${this.documentTitle}${this.excelExtention}`);
  }

  sendExcelToEmail() {
    let excelFile;
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(this.table.nativeElement);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    excelFile = XLSX.writeFile(wb, `${this.documentTitle}${this.excelExtention}`);

    window.location.href = `mailto:t.mylonas@ysoft.gr`;
  }

  async exportToPDF() {
    const body = {
      title: this.report.formTitle,
      description:  this.report.title,
      info: this.infoTable
    };
    console.log(body);
    // this.fileService.onSave(`pdf?uniqueId=${this.uniqueId}&questionId=${this.questionId}&state=${this.state}`, `reportTest.pdf`);
    this.fileService.onSave(`pdf/report`, `${this.documentTitle}${this.pdfExtention}`, body);
  }

  async sendPDFToEmail() {
    try {
      const d = this.dialog.open(EmailInfoDialogComponent, {
        height: '100%',
        width: '100%',
        data: {
          title: `Συμπληρώστε τα πεδία για την αποστολή αναφοράς σε email`
        },
        panelClass: 'full-screen-modal',
      });
      d.afterClosed().subscribe(async (result) => {
        if (result) {
          console.log(result);
          if (result.subject && result.emails) {
            const options = JSON.stringify(result);
            //  tslint:disable-next-line:max-line-length
            const res = await this.commonService.getList(`pdf/mail?options=${options}&uniqueId=${this.uniqueId}&questionId=${this.questionId}&state=${this.state}`);
            this.toastMessagesService.toastMessages(`${res.object}`);
          }
        }
      });
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    }
  }

  formatData() {
    const allInfo = [];
    if (this.report) {

      for (const info of this.report.acceptedInfo) {
        info.status = 1;
        if (+this.state === 0 || +this.state === 1) {
          allInfo.push(info);
        }
      }
      for (const info of this.report.declinedInfo) {
        info.status = 0;
        if (+this.state === 0 || +this.state === 2) {
          allInfo.push(info);
        }
      }
      for (const info of this.report.pendingInfo) {
        info.status = -1;
        if (+this.state === 0 || +this.state === -1) {
          allInfo.push(info);
        }
      }

      for (const info of allInfo) {
        const model = {
          childId: info.childInfo.id,
          childName: `${info.childInfo.firstName}`,
          childLastName: info.childInfo.lastName,
          childClass: info.childInfo.className,
          school: info.childInfo.school,
          status: info.status,
          consentDate: info.completed_at ? info.completed_at : '-',
          fatherDisplayName: info.fatherInfo.id ? `${info.fatherInfo.firstName} ${info.fatherInfo.lastName}` : '-',
          motherDisplayName: info.motherInfo.id ? `${info.motherInfo.firstName} ${info.motherInfo.lastName}` : '-',
        };
        this.infoTable.push(model);
      }
    }
  }
}
